import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { franchiseApi } from '../services/franchiseApi';
import { emitNotificationsChanged, isSafeRoute } from '../services/notificationEvents';
import type { AppNotification } from '../types/notifications';

/**
 * Open a notification: read it, and follow its link. Callers mark it read in their own state first —
 * the click has already happened, and the page is usually about to be left for the link, so there is
 * nothing to wait for. The bell is told once the server agrees, so its refetch reads the new count
 * rather than racing the write.
 */
export function useOpenNotification(): (notification: AppNotification) => void {
  const navigate = useNavigate();

  return useCallback(
    (notification: AppNotification) => {
      if (!notification.read_at) {
        franchiseApi
          .markNotificationRead(notification.id)
          .catch(err => console.error('Failed to mark notification read:', err))
          .finally(emitNotificationsChanged);
      }
      // The route comes from the server, so only a path inside this app is followed.
      if (isSafeRoute(notification.route)) navigate(notification.route);
    },
    [navigate]
  );
}
